import React from "react";
import styled, { keyframes } from "styled-components";
import { useSelector } from "react-redux";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const GlobalLoading = () => {
  const isGlobalLoadingEnabled = useSelector(
    (state) => state.common.isGlobalLoadingEnabled
  );

  if (!isGlobalLoadingEnabled) return null;

  return (
    <LoadingWrapper>
      <Spinner />
    </LoadingWrapper>
  );
};

export default GlobalLoading;
